module.exports = __webpack_public_path__ + "static/media/csv.e809ee83.png";